import React from "react";
import "./index.css";
import { ExpMetrics } from "../../../assets/data/metrics";

const Metrices = () => {
  return (
    <section className="metrices-section bg-primary-50 dark:bg-accent-800 md:py-94px py-64px md:px-30px px-20px">
      <div className="m-auto max-w-[1560px]">
        <h2 className="mt-0 text-primary-900 dark:text-accent-100 md:text-3xl text-2xl font-bold mb-32px">
          Here’s what our users experienced
        </h2>
        <div className="md:flex justify-between md:gap-32px gap-20px md:flex-row grid grid-cols-2">
          {ExpMetrics.map((m, i) => (
            <div
              key={i}
              className="flex flex-col md:gap-20px gap-16px justify-between"
            >
              <div className="title flex items-center md:gap-16px gap-12px md:text-xl text-lg font-medium text-primary-800 dark:text-primary-400">
                <div dangerouslySetInnerHTML={{ __html: m.icon }} />
                <label>{m.lablel}</label>
              </div>
              <div className="md:text-4xl text-3xl text-primary-400 dark:text-accent-200 md:text-right text-left font-bold">
                {m.number}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Metrices;
